import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

// Performance optimizations
import { registerSW, isPWA, supportsPWAInstall } from './lib/serviceWorker'
import { initImageOptimization } from './lib/imageOptimization'
import { frontendMonitoring } from './lib/monitoring'
import './utils/unregisterServiceWorkers' // Auto-cleanup in development

// React Query configuration for performance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: 2,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false, // Disable aggressive refetching
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
    },
  },
})

// console.log('App is starting...'); // DISABLED TO STOP SPAM
// console.log('PWA Support:', supportsPWAInstall()); // DISABLED TO STOP SPAM
// console.log('Running as PWA:', isPWA()); // DISABLED TO STOP SPAM

// Initialize performance optimizations (SW registration disabled — old SW caused reload loops)
const initializeOptimizations = () => {
  try {
    // Initialize image lazy loading and optimization
    initImageOptimization({
      rootMargin: '100px',
      threshold: 0.01,
      fadeInDuration: 200,
    });

    // Initialize monitoring
    try {
      const userId = localStorage.getItem('userId') || undefined;
      frontendMonitoring.initialize(userId);
    } catch (error) {
      // Monitoring init failure is non-critical
    }
  } catch (error) {
    // Non-critical initialization failure
  }
};

// Start optimizations
initializeOptimizations();

// Preload critical resources
const preloadCriticalResources = () => {
  // DNS prefetch for API calls
  const apiPrefetch = document.createElement('link');
  apiPrefetch.rel = 'dns-prefetch';
  apiPrefetch.href = window.location.origin;
  document.head.appendChild(apiPrefetch);
};

// Run preloading immediately
preloadCriticalResources();

// Track application startup
try {
  frontendMonitoring.trackBusinessEvent('app_startup', {
    timestamp: Date.now(),
    isPWA: isPWA(),
    supportsPWAInstall: supportsPWAInstall(),
    userAgent: navigator.userAgent,
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight
    }
  });
} catch (error) {
  // console.error('Failed to track app startup:', error); // DISABLED TO STOP SPAM
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
